export default __webpack_public_path__ + "static/media/repair.d0857617.svg";